import { gql } from "@apollo/client";

export const BRANCHES_BY_COMPANY_NAME = gql`
  query branches($company: String) {
    branches(company: $company) {
      _id
      name
    }
  }
`